// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-display-container {
  height: calc(100% - 34px) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/results/error-display/error-display.component.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF","sourcesContent":[".error-display-container {\r\n  height: calc(100% - 34px) !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
